import React, { useCallback, useEffect, useMemo, useRef } from "react";
import { useCookies } from "react-cookie";
import { Link, useNavigate } from "react-router-dom";
// import { DndProvider } from "react-dnd";
// import { HTML5Backend } from "react-dnd-html5-backend";
import moment from "moment";
import ExpandDiv from "./common/ExpandDiv";
import ALWeeklyReport from "./reports/ALWeeklyReport";
import BulkSurveys from "./reports/BulkSurveys";
import CarePlanReport from "./reports/CarePlanReport";
import CaseWorkerNoteSummary from "./reports/CaseWorkerNoteSummary";
import CaseworkerCaseload from "./reports/CaseworkerCaseload";
import CensusReport from "./reports/CensusReport";
import ClientCareAgreement from "./reports/ClientCareAgreement";
import ClientCaseNoteSummary from "./reports/ClientCaseNoteSummary";
// import FormsyIncidentReport from "./reports/FormsyIncidentReport";
import FormsyReport from "./reports/FormsyReport";
import INMonthlyReport from "./reports/INMonthlyReport";
import IncidentReport from "./reports/IncidentReport";
import IndividualCensus from "./reports/IndividualCensus";
import MonthlyReport from "./reports/MonthlyReport";
import MonthlyUnits from "./reports/MonthlyUnits";
import NVIncidentReport from "./reports/NVIncidentReport";
import OhioTrainingDetails from "./reports/OhioTrainingDetails";
import OhioTrainingSignIn from "./reports/OhioTrainingSignIn";
import RecordedServiceIndividual from "./reports/RecordedServiceIndividual";
import RecordedServiceList from "./reports/RecordedServiceList";
import RecordedServiceSpreadsheet from "./reports/RecordedServiceSpreadsheet";
import VOCA from "./reports/VOCA";
// import DragAndDropCard from "./common/DragAndDropCard";
import { ArrayCheck } from "../scripts/helperScripts";
import AssessmentReport from "./reports/AssessmentReport";
import OHParentPartnerReportClients from "./reports/OHParentPartnerReportClients";
import ReportLink from "./reports/ReportLink";

function Reports() {
  const [cookies, setCookie] = useCookies(["ReportFavorites"]);
  const isMountedRef = useRef(true);
  const navigate = useNavigate();

  const safyInfo = JSON.parse(localStorage.getItem("safyInfo"));

  //Route Access Protection
  useEffect(() => {
    if (!safyInfo?.user?.modules?.includes?.("Reports")) {
      navigate("/", { replace: true });
    }
  });

  const userModules = useMemo(() => {
    return safyInfo?.user?.modules || [];
  }, [safyInfo]);

  const userIsAdmin = useMemo(() => {
    return userModules?.includes("Admin");
  }, [userModules]);

  const userIsRevCycle = useMemo(() => {
    return userModules?.includes("Rev Cycle");
  }, [userModules]);

  const userDivisions = useMemo(() => {
    if (!safyInfo?.user?.divisions) {
      return [];
    }

    return safyInfo.user.divisions.map((element) => ({
      _id: element,
      name: element,
    }));
  }, [safyInfo]);

  const userBusinessUnit = useMemo(() => {
    return safyInfo?.user?.safyInfo?.BusinessUnitIdName;
  }, [safyInfo]);

  const favorites = useMemo(() => {
    if (!cookies?.ReportFavorites) {
      return [];
    }

    return ArrayCheck(cookies.ReportFavorites);
  }, [cookies]);

  const ReportPortal = "https://safyreports.azurewebsites.net/Reports/Parents/";
  const dbOrg =
    process.env.REACT_APP_ENVIRONMENT === "Production"
      ? "ReactLive"
      : "ReactDev";
  //const standardReports = {Client: ["Individual Census", "Care Plan Report", "Incident Report", "Nevada Incident Report", "Nevada Deauthorize Client", "Client Case Note Summary", "Client Care Agreement Report", "Monthly Report", "Monthly Report (old)", "IN Monthly Report (old)"]}

  // const moveReport = useCallback(
  //   (dragIndex, hoverIndex) => {
  //     const newFaves = [...cookies.ReportFavorites];
  //     const element = newFaves[dragIndex];
  //     newFaves.splice(dragIndex, 1);
  //     newFaves.splice(hoverIndex, 0, element);

  //     if (cookies.ReportFavorites !== newFaves) {
  //       setCookie("ReportFavorites", JSON.stringify(newFaves), {
  //         expires: moment().add(1, "year").toDate(),
  //       });
  //     }
  //   },
  //   [cookies.ReportFavorites, setCookie]
  // );

  useEffect(() => {
    document.title = "SAFY Portal - Reports";
    return () => {
      document.title = "SAFY Portal";
      isMountedRef.current = false;
    };
  }, []);

  // useEffect(() => {
  //   getAccessToken();
  // }, [history]);

  // const getAccessToken = async () => {
  //   const token = await msalInstance.acquireTokenSilent({
  //     scopes: loginRequest,
  //   });
  //   console.log("PBI Token:", token);
  //   setAccessToken(token.accessToken);
  // };

  const openUnconfirmedBDS = () => {
    const url = `${process.env.REACT_APP_ORG}/main.aspx?etc=10021&pagetype=entitylist&viewid=%7bE01178C9-C1F5-E511-8588-005056822045%7d&viewtype=4230`;
    window.open(url);
  };

  const openDashboards = () => {
    const url =
      process.env.REACT_APP_ENVIRONMENT !== "Production"
        ? `${process.env.REACT_APP_ORG}/workplace/home_dashboards.aspx`
        : `${process.env.REACT_APP_ORG}/main.aspx?pagetype=dashboard`;
    window.open(url);
  };

  const openPowerBI = () => {
    const url = `https://app.powerbi.com`;
    window.open(url);
  };

  const toggleFavorite = useCallback(
    (reportName) => {
      let newFaves = [];

      if (cookies.ReportFavorites) {
        newFaves = [...cookies.ReportFavorites];
      }

      if (newFaves.includes(reportName)) {
        newFaves = newFaves.filter((fave) => fave !== reportName);
      } else {
        newFaves.push(reportName);
      }

      setCookie("ReportFavorites", JSON.stringify(newFaves), {
        expires: moment().add(1, "year").toDate(),
      });
    },
    [cookies.ReportFavorites, setCookie]
  );

  // const getFaveReport = useCallback(
  //   (value) => {
  //     const reportsPortal =
  //       "https://safyreports.azurewebsites.net/Reports/Parents/";
  //     const reactOrg =
  //       process.env.REACT_APP_ENVIRONMENT === "Production"
  //         ? "ReactLive"
  //         : "ReactDev";

  //     switch (value) {
  //       case "Individual Census":
  //         return (
  //           <IndividualCensus
  //             className="border p-2 mb-4 card-safy bg-safy2-5"
  //             divisions={userDivisions}
  //             isFavorite={true}
  //             toggleFavorite={toggleFavorite}
  //             inFavoritesSection={true}
  //           />
  //         );
  //       case "SAFY Assessment":
  //         return (
  //           <AssessmentReport
  //             className="border p-2 mb-4 card-safy bg-safy2-5"
  //             divisions={userDivisions}
  //             isFavorite={true}
  //             toggleFavorite={toggleFavorite}
  //             inFavoritesSection={true}
  //           />
  //         );
  //       case "Care Plan Report":
  //         return (
  //           <CarePlanReport
  //             className="border p-2 mb-4 card-safy bg-safy2-5"
  //             divisions={userDivisions}
  //             isFavorite={true}
  //             toggleFavorite={toggleFavorite}
  //             inFavoritesSection={true}
  //           ></CarePlanReport>
  //         );
  //       case "Incident Report":
  //         return (
  //           <IncidentReport
  //             className="border p-2 mb-4 card-safy bg-safy2-5"
  //             divisions={userDivisions}
  //             isFavorite={true}
  //             toggleFavorite={toggleFavorite}
  //             inFavoritesSection={true}
  //           ></IncidentReport>
  //         );
  //       case "Nevada Incident Report":
  //         return (
  //           <NVIncidentReport
  //             className="border p-2 mb-4 card-safy bg-safy2-5"
  //             isFavorite={true}
  //             toggleFavorite={toggleFavorite}
  //             inFavoritesSection={true}
  //           ></NVIncidentReport>
  //         );
  //       case "Nevada Deauthorize Client":
  //         return (
  //           <ReportLink
  //             className="border p-2 mb-4 card-safy bg-safy2-5"
  //             title="Nevada Deauthorize Client"
  //             url="https://safyreports.azurewebsites.net/Processes/Nevada/Deauthorize/Default"
  //             isFavorite={true}
  //             toggleFavorite={toggleFavorite}
  //             inFavoritesSection={true}
  //           />
  //         );
  //       case "Client Case Note Summary":
  //         return (
  //           <ClientCaseNoteSummary
  //             className="border p-2 mb-4 card-safy bg-safy2-5"
  //             divisions={userDivisions}
  //             isFavorite={true}
  //             toggleFavorite={toggleFavorite}
  //             inFavoritesSection={true}
  //           ></ClientCaseNoteSummary>
  //         );
  //       case "Client Care Agreement Report":
  //         return (
  //           <ClientCareAgreement
  //             className="border p-2 mb-4 card-safy bg-safy2-5"
  //             divisions={userDivisions}
  //             isFavorite={true}
  //             toggleFavorite={toggleFavorite}
  //             inFavoritesSection={true}
  //           ></ClientCareAgreement>
  //         );
  //       case "Monthly Report":
  //         return (
  //           <FormsyReport
  //             className="border p-2 mb-4 card-safy bg-safy2-5"
  //             reportType="MonthlyReport"
  //             title="Monthly Report"
  //             isFavorite={true}
  //             toggleFavorite={toggleFavorite}
  //             inFavoritesSection={true}
  //           ></FormsyReport>
  //         );
  //       case "Monthly Report (old)":
  //         return (
  //           <MonthlyReport
  //             className="border p-2 mb-4 card-safy bg-safy2-5"
  //             isFavorite={true}
  //             toggleFavorite={toggleFavorite}
  //             inFavoritesSection={true}
  //           ></MonthlyReport>
  //         );
  //       case "IN Monthly Report (old)":
  //         return (
  //           <INMonthlyReport
  //             className="border p-2 mb-4 card-safy bg-safy2-5"
  //             divisions={userDivisions}
  //             isFavorite={true}
  //             toggleFavorite={toggleFavorite}
  //             inFavoritesSection={true}
  //           ></INMonthlyReport>
  //         );
  //       case "Recorded Service List":
  //         return (
  //           <RecordedServiceList
  //             className="border p-2 mb-4 card-safy bg-safy2-5"
  //             divisions={userDivisions}
  //             isFavorite={true}
  //             toggleFavorite={toggleFavorite}
  //             inFavoritesSection={true}
  //           ></RecordedServiceList>
  //         );
  //       case "Recorded Service Spreadsheet":
  //         return (
  //           <RecordedServiceSpreadsheet
  //             className="border p-2 mb-4 card-safy bg-safy2-5"
  //             divisions={userDivisions}
  //             isFavorite={true}
  //             toggleFavorite={toggleFavorite}
  //             inFavoritesSection={true}
  //           ></RecordedServiceSpreadsheet>
  //         );
  //       case "Recorded Service Individual":
  //         return (
  //           <RecordedServiceIndividual
  //             className="border p-2 mb-4 card-safy bg-safy2-5"
  //             divisions={userDivisions}
  //             isFavorite={true}
  //             toggleFavorite={toggleFavorite}
  //             inFavoritesSection={true}
  //           ></RecordedServiceIndividual>
  //         );
  //       case "AL Covid-19 Report":
  //         return (
  //           <ReportLink
  //             className="border p-2 mb-4 card-safy bg-safy2-5"
  //             title="AL Covid-19 Report"
  //             url={`https://safyreports.azurewebsites.net/Reports/Formsy/ALCovid/Default?db=${reactOrg}`}
  //             isFavorite={true}
  //             toggleFavorite={toggleFavorite}
  //             inFavoritesSection={true}
  //           />
  //         );
  //       case "AL FP Grid Report":
  //         return (
  //           <ReportLink
  //             className="border p-2 mb-4 card-safy bg-safy2-5"
  //             title="AL FP Grid Report"
  //             url={`${reportsPortal}ALGrid`}
  //             isFavorite={true}
  //             toggleFavorite={toggleFavorite}
  //             inFavoritesSection={true}
  //           />
  //         );
  //       case "AL FP Note Report":
  //         return (
  //           <ReportLink
  //             className="border p-2 mb-4 card-safy bg-safy2-5"
  //             title="AL FP Note Report"
  //             url={`${reportsPortal}ALNote`}
  //             isFavorite={true}
  //             toggleFavorite={toggleFavorite}
  //             inFavoritesSection={true}
  //           />
  //         );
  //       case "Caseworker Note Summary":
  //         return (
  //           <CaseWorkerNoteSummary
  //             className="border p-2 mb-4 card-safy bg-safy2-5"
  //             divisions={userDivisions}
  //             isFavorite={true}
  //             toggleFavorite={toggleFavorite}
  //             inFavoritesSection={true}
  //           ></CaseWorkerNoteSummary>
  //         );
  //       case "Caseworker Caseload Count":
  //         return (
  //           <CaseworkerCaseload
  //             className="border p-2 mb-4 card-safy bg-safy2-5"
  //             isFavorite={true}
  //             toggleFavorite={toggleFavorite}
  //             inFavoritesSection={true}
  //           ></CaseworkerCaseload>
  //         );
  //       case "Division Census":
  //         return (
  //           <CensusReport
  //             className="border p-2 mb-4 card-safy bg-safy2-5"
  //             isFavorite={true}
  //             toggleFavorite={toggleFavorite}
  //             inFavoritesSection={true}
  //           />
  //         );
  //       case "Monthly Units":
  //         return (
  //           <MonthlyUnits
  //             className="border p-2 mb-4 card-safy bg-safy2-5"
  //             isFavorite={true}
  //             toggleFavorite={toggleFavorite}
  //             inFavoritesSection={true}
  //           ></MonthlyUnits>
  //         );
  //       case "FP Rules Investigation":
  //         return (
  //           <ReportLink
  //             className="border p-2 mb-4 card-safy bg-safy2-5"
  //             title="FP Rules Investigation"
  //             url={`https://safyreports.azurewebsites.net/Reports/Incident/RulesInvestigation?db=SOARLive&bu=${userBusinessUnit}`}
  //             isFavorite={true}
  //             toggleFavorite={toggleFavorite}
  //             inFavoritesSection={true}
  //           />
  //         );
  //       case "F223 & F22A Bulk Surveys":
  //         return (
  //           <BulkSurveys
  //             className="border p-2 mb-4 card-safy bg-safy2-5"
  //             divisions={userDivisions}
  //             isFavorite={true}
  //             toggleFavorite={toggleFavorite}
  //             inFavoritesSection={true}
  //           ></BulkSurveys>
  //         );
  //       case "VOCA":
  //         return (
  //           <VOCA
  //             className="border p-2 mb-4 card-safy bg-safy2-5"
  //             isFavorite={true}
  //             toggleFavorite={toggleFavorite}
  //             inFavoritesSection={true}
  //           ></VOCA>
  //         );
  //       case "Ohio Training Sign Ins":
  //         return (
  //           <OhioTrainingSignIn
  //             className="border p-2 mb-4 card-safy bg-safy2-5"
  //             isFavorite={true}
  //             toggleFavorite={toggleFavorite}
  //             inFavoritesSection={true}
  //           ></OhioTrainingSignIn>
  //         );
  //       case "Ohio Training Details":
  //         return (
  //           <OhioTrainingDetails
  //             className="border p-2 mb-4 card-safy bg-safy2-5"
  //             isFavorite={true}
  //             toggleFavorite={toggleFavorite}
  //             inFavoritesSection={true}
  //           ></OhioTrainingDetails>
  //         );
  //       case "Parent Partner Assessment Report":
  //         return (
  //           <OHParentPartnerReportClients
  //             className="border p-2 mb-4 card-safy bg-safy2-5"
  //             isFavorite={true}
  //             toggleFavorite={toggleFavorite}
  //             inFavoritesSection={true}
  //           ></OHParentPartnerReportClients>
  //         );
  //       default:
  //         return <></>;
  //     }
  //   },
  //   [userDivisions, userBusinessUnit, toggleFavorite]
  // );

  // const renderFavorites = useCallback(() => {
  //   return favorites.map((value, index) => {
  //     return (
  //       <DragAndDropCard
  //         id={value}
  //         key={value}
  //         index={index}
  //         type="Report"
  //         moveCard={moveReport}
  //       >
  //         {getFaveReport(value)}
  //       </DragAndDropCard>
  //     );
  //   });
  // }, [favorites, moveReport, getFaveReport]);

  return (
    <>
      <div className="clearfix mb-4">
        <div className="h3 float-start">Reports</div>
        <div className="float-end">
          <button className="btn btn-primary me-2" onClick={openPowerBI}>
            Power BI
          </button>
          <button className="btn btn-primary me-2" onClick={openDashboards}>
            SOAR Dashboards
          </button>
          <button className="btn btn-primary me-2" onClick={openUnconfirmedBDS}>
            View Unconfirmed BDS
          </button>
          {userIsAdmin || userIsRevCycle ? (
            <Link
              title="Fast Time Entry"
              to="/FastTimeEntry"
              className="btn btn-primary"
            >
              Fast Time Entry
            </Link>
          ) : null}
        </div>
      </div>
      {/* <button
        className="mb-4 btn btn-safy-info"
        onClick={() => {
          window.open(ReportPortal, "Report Portal");
        }}
      >
        Open Reports Portal
      </button> */}
      {/* <ExpandDiv
        id="Favorites"
        title="Favorites"
        expandStatus={true}
        preserveChildren={true}
      >
        <DndProvider backend={HTML5Backend}>{renderFavorites()}</DndProvider>
      </ExpandDiv> */}
      <ExpandDiv id="Client" title="Client" preserveChildren={true}>
        <IndividualCensus
          className="border p-2 mb-4 card-safy bg-safy2-5"
          divisions={userDivisions}
          isFavorite={favorites.includes("Individual Census")}
          toggleFavorite={toggleFavorite}
        />
        <CarePlanReport
          className="border p-2 mb-4 card-safy bg-safy2-5"
          divisions={userDivisions}
          isFavorite={favorites.includes("Care Plan Report")}
          toggleFavorite={toggleFavorite}
        ></CarePlanReport>
        {/* <FormsyIncidentReport
          className="border p-2 mb-4 card-safy bg-safy2-5"
          divisions={userDivisions}
          isFavorite={favorites.includes("Incident Report (Portal)")}
          toggleFavorite={toggleFavorite}
        /> */}
        {userBusinessUnit !== "SAFY of Nevada" && (
          <IncidentReport
            className="border p-2 mb-4 card-safy bg-safy2-5"
            divisions={userDivisions}
            isFavorite={favorites.includes("Incident Report")}
            toggleFavorite={toggleFavorite}
          ></IncidentReport>
        )}
        {userBusinessUnit === "SAFY of Nevada" ||
        userBusinessUnit === "ccplive" ? (
          <>
            <NVIncidentReport
              className="border p-2 mb-4 card-safy bg-safy2-5"
              isFavorite={favorites.includes("Nevada Incident Report")}
              toggleFavorite={toggleFavorite}
            ></NVIncidentReport>
            <ReportLink
              className="border p-2 mb-4 card-safy bg-safy2-5"
              title="Nevada Deauthorize Client"
              url={`https://safyreports.azurewebsites.net/Processes/Nevada/Deauthorize/Default`}
              isFavorite={favorites.includes("Nevada Deauthorize Client")}
              toggleFavorite={toggleFavorite}
            />
          </>
        ) : null}
        <ClientCaseNoteSummary
          className="border p-2 mb-4 card-safy bg-safy2-5"
          divisions={userDivisions}
          isFavorite={favorites.includes("Client Case Note Summary")}
          toggleFavorite={toggleFavorite}
        ></ClientCaseNoteSummary>
        <ClientCareAgreement
          className="border p-2 mb-4 card-safy bg-safy2-5"
          divisions={userDivisions}
          isFavorite={favorites.includes("Client Care Agreement Report")}
          toggleFavorite={toggleFavorite}
        ></ClientCareAgreement>
        <AssessmentReport
          className="border p-2 mb-4 card-safy bg-safy2-5"
          isFavorite={favorites.includes("SAFY Assessment")}
          toggleFavorite={toggleFavorite}
        />
        <FormsyReport
          className="border p-2 mb-4 card-safy bg-safy2-5"
          reportType="MonthlyReport"
          title="Monthly Report"
          isFavorite={favorites.includes("Monthly Report")}
          toggleFavorite={toggleFavorite}
        ></FormsyReport>
        <MonthlyReport
          className="border p-2 mb-4 card-safy bg-safy2-5"
          isFavorite={favorites.includes("Monthly Report (old)")}
          toggleFavorite={toggleFavorite}
        ></MonthlyReport>
        {userBusinessUnit === "SAFY of Indiana" ||
        userBusinessUnit === "ccplive" ||
        userModules.includes("Sys Admin") ? (
          <INMonthlyReport
            className="border p-2 mb-4 card-safy bg-safy2-5"
            divisions={userDivisions}
            isFavorite={favorites.includes("IN Monthly Report (old)")}
            toggleFavorite={toggleFavorite}
          ></INMonthlyReport>
        ) : null}
        <RecordedServiceList
          className="border p-2 mb-4 card-safy bg-safy2-5"
          divisions={userDivisions}
          isFavorite={favorites.includes("Recorded Service List")}
          toggleFavorite={toggleFavorite}
        ></RecordedServiceList>
        <RecordedServiceSpreadsheet
          className="border p-2 mb-4 card-safy bg-safy2-5"
          divisions={userDivisions}
          isFavorite={favorites.includes("Recorded Service Spreadsheet")}
          toggleFavorite={toggleFavorite}
        ></RecordedServiceSpreadsheet>
        <RecordedServiceIndividual
          className="border p-2 mb-4 card-safy bg-safy2-5"
          divisions={userDivisions}
          isFavorite={favorites.includes("Recorded Service Individual")}
          toggleFavorite={toggleFavorite}
        ></RecordedServiceIndividual>
        <OHParentPartnerReportClients
          className="border p-2 mb-4 card-safy bg-safy2-5"
          isFavorite={favorites.includes("Parent Partner Assessment Report")}
          toggleFavorite={toggleFavorite}
        ></OHParentPartnerReportClients>
        {userBusinessUnit === "SAFY of Alabama" ||
        userBusinessUnit === "ccplive" ||
        userModules.includes("Sys Admin") ? (
          <>
            <ReportLink
              className="border p-2 mb-4 card-safy bg-safy2-5"
              title="AL Covid-19 Report"
              url={`https://safyreports.azurewebsites.net/Reports/Formsy/ALCovid/Default?db=${dbOrg}`}
              isFavorite={favorites.includes("AL Covid-19 Report")}
              toggleFavorite={toggleFavorite}
            />
            <ReportLink
              className="border p-2 mb-4 card-safy bg-safy2-5"
              title="AL FP Grid Report"
              url={`${ReportPortal}ALGrid`}
              isFavorite={favorites.includes("AL FP Grid Report")}
              toggleFavorite={toggleFavorite}
            />
            <ReportLink
              className="border p-2 mb-4 card-safy bg-safy2-5"
              title="AL FP Note Report"
              url={`${ReportPortal}ALNote`}
              isFavorite={favorites.includes("AL FP Note Report")}
              toggleFavorite={toggleFavorite}
            />
            {process.env.REACT_APP_ENVIRONMENT !== "Production" ? (
              <ALWeeklyReport
                className="border p-2 mb-4 card-safy bg-safy2-5"
                title="AL Weekly Report"
                isFavorite={favorites.includes("AL Weekly Report")}
                toggleFavorite={toggleFavorite}
              />
            ) : null}
          </>
        ) : null}
      </ExpandDiv>
      <ExpandDiv id="Worker" title="Worker" preserveChildren={true}>
        <CaseWorkerNoteSummary
          className="border p-2 mb-4 card-safy bg-safy2-5"
          divisions={userDivisions}
          isFavorite={favorites.includes("Caseworker Note Summary")}
          toggleFavorite={toggleFavorite}
        ></CaseWorkerNoteSummary>
        <CaseworkerCaseload
          className="border p-2 mb-4 card-safy bg-safy2-5"
          isFavorite={favorites.includes("Caseworker Caseload Count")}
          toggleFavorite={toggleFavorite}
        ></CaseworkerCaseload>
      </ExpandDiv>
      <ExpandDiv id="General" title="General" preserveChildren={true}>
        <CensusReport
          className="border p-2 mb-4 card-safy bg-safy2-5"
          isFavorite={favorites.includes("Division Census")}
          toggleFavorite={toggleFavorite}
        />
        <MonthlyUnits
          className="border p-2 mb-4 card-safy bg-safy2-5"
          isFavorite={favorites.includes("Monthly Units")}
          toggleFavorite={toggleFavorite}
        ></MonthlyUnits>
        <ReportLink
          className="border p-2 mb-4 card-safy bg-safy2-5"
          title="FP Rules Investigation"
          url={`https://safyreports.azurewebsites.net/Reports/Incident/RulesInvestigation?db=SOARLive&bu=${userBusinessUnit}`}
          isFavorite={favorites.includes("FP Rules Investigation")}
          toggleFavorite={toggleFavorite}
        />
        <BulkSurveys
          className="border p-2 mb-4 card-safy bg-safy2-5"
          divisions={userDivisions}
          isFavorite={favorites.includes("F223 & F22A Bulk Surveys")}
          toggleFavorite={toggleFavorite}
        ></BulkSurveys>
        {userBusinessUnit === "SAFY of Ohio" ||
        userBusinessUnit === "ccplive" ||
        userModules.includes("Sys Admin") ? (
          <>
            <VOCA
              className="border p-2 mb-4 card-safy bg-safy2-5"
              isFavorite={favorites.includes("VOCA")}
              toggleFavorite={toggleFavorite}
            ></VOCA>
            <OhioTrainingSignIn
              className="border p-2 mb-4 card-safy bg-safy2-5"
              isFavorite={favorites.includes("Ohio Training Sign Ins")}
              toggleFavorite={toggleFavorite}
            ></OhioTrainingSignIn>
            <OhioTrainingDetails
              className="border p-2 mb-4 card-safy bg-safy2-5"
              isFavorite={favorites.includes("Ohio Training Details")}
              toggleFavorite={toggleFavorite}
            ></OhioTrainingDetails>
          </>
        ) : null}
      </ExpandDiv>
      {/* <iframe
        title="PowerBI"
        width="1140"
        height="541.25"
        src="https://app.powerbi.com/reportEmbed?reportId=e3106e95-5104-406c-b3bd-601b70f7ea9b&autoAuth=true&ctid=e032c41f-46dd-4868-ac74-b93673b44abd&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXVzLW5vcnRoLWNlbnRyYWwtYy1wcmltYXJ5LXJlZGlyZWN0LmFuYWx5c2lzLndpbmRvd3MubmV0LyJ9"
        frameborder="0"
        allowFullScreen="true"
      ></iframe> */}
      {/* <PowerBIEmbed
        embedConfig={{
          type: "dashboard", // Supported types: report, dashboard, tile, visual and qna
          id: "0a4527fd-8ed0-4151-aefc-3c882a92e0d4",
          embedUrl:
            "https://app.powerbi.com/groups/4e39035e-26e2-4e27-9d9b-ac44d2d90247/dashboards/0a4527fd-8ed0-4151-aefc-3c882a92e0d4?ctid=e032c41f-46dd-4868-ac74-b93673b44abd",
          accessToken: accessToken,
        }}
        eventHandlers={
          new Map([
            [
              "loaded",
              function () {
                console.log("Report loaded");
              },
            ],
            [
              "rendered",
              function () {
                console.log("Report rendered");
              },
            ],
            [
              "error",
              function (event) {
                console.log(event.detail);
              },
            ],
          ])
        }
        cssClassName={"report-style-class"}
      /> */}
    </>
  );
}

export default Reports;
